/* eslint-disable react/no-array-index-key */
import Heading from 'molecules/Heading';
import Image from 'molecules/Image';
import Section from 'molecules/Section';
import VideoCustom from 'molecules/VideoCustom';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';

import type { FC } from 'react';

const HeroCustomer: FC<HeroCustomerProps> = ({
  title,
  summary,
  featuredVideo,
  featuredVideoThumbnail,
  featuredImage,
  children,
  metrics,
}) => {
  // Stories without a usable video still need a visual on the right: fall
  // back to a static image. The thumbnail wins over featuredImage because
  // featuredImage doubles as the OG/listing card image.
  const heroImage = featuredVideoThumbnail ?? featuredImage;
  const heroImageAspect = heroImage?.width && heroImage?.height ? `${heroImage.width} / ${heroImage.height}` : '16 / 9';

  return (
    <Section hasGradientDark paddingTop="lg" paddingBottom="xl" darkMode>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div className="flex max-w-[600px] flex-col gap-6">
          <Heading heading={title} body={summary} alignment="left" as="h1" animateOnMount>
            {children && children}
          </Heading>

          {metrics && (
            <ScrollFadeSection delay={0.4} animateOnMount>
              <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
                {metrics.map((metric, index) => (
                  <div key={index} className="flex flex-col">
                    <span className="font-spaceGrotesk text-display-xl leading-none text-primary-300 lg:text-display-xl">
                      {metric?.value}
                    </span>
                    <p className="mt-1 text-lg leading-6 text-white sm:text-xl">{metric?.heading}</p>
                    {metric?.description && (
                      <div className="mt-2 text-lg text-body dark:text-gray-300">{metric.description}</div>
                    )}
                  </div>
                ))}
              </div>
            </ScrollFadeSection>
          )}
        </div>

        <div className="flex justify-center">
          {featuredVideo && (
            <div className="size-full">
              <VideoCustom
                videoSrc={featuredVideo}
                thumbnail={featuredVideoThumbnail}
                key={featuredVideo}
                priority={true}
              />
            </div>
          )}
          {!featuredVideo && heroImage && (
            <div
              className="relative mx-auto w-full max-w-[800px] overflow-hidden rounded-lg"
              style={{ aspectRatio: heroImageAspect }}
            >
              <Image
                {...(heroImage.file || heroImage)}
                className="size-full"
                alt={heroImage.alt || title || ''}
                priority
                objectCover
                unsetRatio
                unsetMaxW
              />
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};

export default HeroCustomer;
